import React, { useState } from 'react'
import { StyleSheet } from 'react-native'
import { ZoomView, ZoomViewProps } from 'zens-storybook'

const styles = StyleSheet.create({
  container: {
    width: '100%',
  },
})

export interface Props extends Omit<ZoomViewProps, 'onContentSizeChange'> {}

const FloorplanZoomView = (props: Props) => {
  const { style, children, ...otherProps } = props
  const [size, setSize] = useState({ width: 0, height: 0 })

  function scale(width: number, height: number) {
    setSize({ width, height })
  }

  return (
    <ZoomView
      style={[styles.container, style, { aspectRatio: size.width / size.height }]}
      onContentSizeChange={scale}
      {...otherProps}
    >
      {children}
    </ZoomView>
  )
}

export default FloorplanZoomView
